import React, { useState,useEffect, forwardRef, useImperativeHandle } from "react";
import "../../../../css/salesorder.css";
import {
    GetOrderDetailGridData
} from "../../../../services/SalesOrderService";
import OrderDetailResult from "../salesOrdersTab/OrderDetailResult";
import AROpenItemsResult from "../salesOrdersTab/AROpenItemsResult";
import ItemMasterResult from "../salesOrdersTab/ItemMasterResult";
import CustomerResult from "../salesOrdersTab/CustomerResult";
import CustomerContactResult from "../salesOrdersTab/CustomerContactResult";
const EdiWebTabs = forwardRef((props, ref) => {
    const orderDetailTab = 1;
    const arOpenItemsTab = 2;
    const itemMasterTab = 3;
    const customerTab = 4;
    const customerContactTab = 5;
    const getOrderDetailSearchUrl = "om/SaleOrder/OrderDetailSearch";
    const GetCustomerConcatsUrl = "om/SaleOrder/GetCustomerConcats";
    const [orderDetailDataSource, setOrderDetailDataSource] = useState(null);;
    const [customerContactDataSource, setCustomerContactDataSource] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);
    const [activeTab, setActiveTab] = useState(orderDetailTab);
    const [arOpenItemsDataSource, setArOpenItemsDataSource] = useState(null);
    const [ItemMasterDataSource, setItemMasterDataSource] = useState(null);
    const [customerDataSource, setCustomerDataSource] = useState(null);
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };
    const LoadTabsData = () => {
        if (selectedRow) {
            if (selectedRow.rowid && activeTab === orderDetailTab) {
                var resultData = GetOrderDetailGridData(props.accessToken, getOrderDetailSearchUrl, selectedRow.rowid);
                setOrderDetailDataSource(resultData);
            } else if (selectedRow.rCustomer && activeTab === customerContactTab) {
                var resultData = GetOrderDetailGridData(props.accessToken, GetCustomerConcatsUrl, selectedRow.rCustomer);
                setCustomerContactDataSource(resultData);
            }
        }
    }
    useImperativeHandle(ref, () => ({
        updateData(data) {
            setSelectedRow(data);
        }
    }));
    useEffect(() => {
        LoadTabsData();
    }, [selectedRow, activeTab]);
    return (
        <div>
            <div className="tab-bar">
                <div
                    className={`tab ${activeTab === orderDetailTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(orderDetailTab)}
                >
                    Order Detail
                </div>
                <div
                    className={`tab ${activeTab === customerContactTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(customerContactTab)}
                >
                    Customer Contact
                </div>
            </div>
            {activeTab === orderDetailTab && (
                <OrderDetailResult data={orderDetailDataSource} />
            )}
            {activeTab === arOpenItemsTab && (
                <AROpenItemsResult data={arOpenItemsDataSource} />
            )}
            {activeTab === itemMasterTab && (
                <ItemMasterResult data={ItemMasterDataSource} />
            )}
            {activeTab === customerTab && (
                <CustomerResult data={customerDataSource} />
            )}
            {activeTab === customerContactTab && (
                <CustomerContactResult data={customerContactDataSource} />
            )}
        </div>
    );
});

export default EdiWebTabs;